function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// @ts-nocheck
import { Space } from 'antd';
import React from 'react';
import styles from "./index.module.css";
import nl2br from "../utils/nl2br";
var CSVNoticeItem = function CSVNoticeItem(_ref) {
  var header = _ref.header,
    values = _ref.values,
    description = _ref.description;
  return /*#__PURE__*/React.createElement(Space, {
    align: "start",
    className: "".concat(styles.item, " wand-csv-notice-item"),
    key: header
  }, /*#__PURE__*/React.createElement("code", null, header), /*#__PURE__*/React.createElement("div", null, nl2br(description), values && values.length > 0 && /*#__PURE__*/React.createElement("ul", null, values.map(function (_ref2) {
    var value = _ref2.value,
      description = _ref2.description;
    return /*#__PURE__*/React.createElement("li", {
      key: value
    }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement("strong", null, value), description));
  }))));
};
var CSVNotice = function CSVNotice(props) {
  var _props$schema = props.schema,
    schema = _props$schema === void 0 ? [] : _props$schema;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.container, " wand-csv-notice-container")
  }, /*#__PURE__*/React.createElement(Space, {
    direction: "vertical",
    style: {
      width: '100%'
    }
  }, schema.map(function (item) {
    return /*#__PURE__*/React.createElement(CSVNoticeItem, _extends({
      key: item.header
    }, item));
  })));
};
export default CSVNotice;